export default __webpack_public_path__ + "static/media/notificationIcon.235bce7a.svg";